import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postMarkCustomerAsActive = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}customers/activate/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

export default postMarkCustomerAsActive;
